import { useCallback } from 'react';

import { useMutateUnlinkDevice } from '@/hooks/mutation/desktop/chronicle/useMutateUnlinkDevice';

/**
 * Hook for unlinking a Chronicle device from the backend.
 *
 * Handles DELETE /hardware-device/{id} only. Binding code is intentionally
 * preserved — it is account-scoped and shared across all devices for encryption.
 *
 * Does NOT handle BLE disconnect, device reset, or local state cleanup —
 * callers (e.g. forgetDevice) are responsible for that.
 */
export function useChronicleUnlinkDevice() {
  const { mutateAsync: unlinkDeviceAsync } = useMutateUnlinkDevice();

  const unlinkDevice = useCallback(
    async (deviceId: string) => {
      await unlinkDeviceAsync(deviceId);
    },
    [unlinkDeviceAsync]
  );

  return { unlinkDevice };
}
